import { ItiBaseDto } from '@/iti-core-vue';
import { TemplateOfferDemand } from './template-offer-demand';

export class MatchingOfferDemand extends ItiBaseDto {    
    public id!: number;
    
    //MatchingOfferDemandDto
    public offerDemandId!: number;
    public ambitId!: number;
    public algorithmName!: string;
    public algorithmDescription!: string;
    public result!: number;
    public company!: string;
    public location!: string;
    // public interested!: boolean;
    public templateOfferDemandList!: TemplateOfferDemand[];
    
    //ResponseAlgorithmDto
    public algorithmId!: number;
    public name!: string;
    public description!: string;
    public offerId !: string;
    public demandId !: string;
    public value !: number;
    public interestedOffer !: boolean;
    public dateInterestedOffer !: Date;
    public interestedDemand !: boolean;
    public dateInterestedDemand !: Date;
    public offeringUserId !: number;
    public demandingUserId !: number;
    public collaborativeAreaCreated !: boolean;
    public collaborativeAreaId !: number;
}